/**
 * Color-coded state pill for RTR commands. Uses semantic tokens only.
 * Mapping per LOVABLE_TODO.md (2026-06-06).
 */
import { cn } from "@/lib/utils";
import type { RtrState } from "@/types/edr-rtr";

const STATE_STYLES: Record<RtrState, string> = {
  queued: "bg-muted text-muted-foreground border-border",
  delivered: "bg-info/10 text-info border-info/30",
  acked: "bg-primary/10 text-primary border-primary/30",
  completed: "bg-success-muted text-success border-success/30",
  failed: "bg-destructive/10 text-destructive border-destructive/30",
  expired: "bg-warning-muted text-warning border-warning/30",
  cancelled: "bg-muted text-muted-foreground border-border",
};

export function RtrStatePill({ state, className }: { state: RtrState; className?: string }) {
  return (
    <span
      className={cn(
        "inline-flex items-center rounded-full border px-2 py-0.5 text-[10px] font-medium uppercase tracking-wider tabular-nums",
        STATE_STYLES[state],
        className,
      )}
    >
      {state}
    </span>
  );
}
